import { useTranslation } from 'react-i18next'
import { Button, Col, Modal, Row } from 'react-bootstrap'

import '../../../../../planograms_v2/components/advanceFilter.scss'

const CopyArrangementValidationModal = ({
    dir,
    dmode,
    showModal,
    simulationObj,
    toggleFunc,
    rowData,
    searchObj,
    diffrentDimentionChangeObject,
    getSimulationCallCopyArrangement,
}) => {
    const { t } = useTranslation()
    const payloadCreateFunction = () => {


        const snapshotId = diffrentDimentionChangeObject?.simulationSnapshotId ||
                          diffrentDimentionChangeObject?.snapshotId ||
                          rowData?.snapshotId

        const fieldCount = diffrentDimentionChangeObject?.fieldCount ||
                          rowData?.fieldCount ||
                          1  // default fallback


        if (!snapshotId) {
            console.error('No snapshotId available in any source:', {
                diffrentDimentionChangeObject,
                rowData
            })
            return
        }

        const payload = { snapshotId: snapshotId }
        getSimulationCallCopyArrangement(payload, fieldCount)
    }

    const msgType =
        diffrentDimentionChangeObject?.differenceType ===
        'FIELD_STRUCTURE_DIFFERENT'
            ? 'FIELD_DIMENSION_MISMATCH_MSG'
            : diffrentDimentionChangeObject?.differenceType ===
              'SHELF_COUNT_MISMATCH'
            ? 'SHELF_COUNT_MISMATCH_MSG'
            : 'SHELF_MISMATCH_MSG'

    
    
    //Field at position 1 has different dimensions after processing. Existing (snapshot 8754): h=100, w=150, d=10, order=1, count=1. Incoming: h=150, w=120, d=10, order=1';

    return (
        <>
            <Modal show={showModal} onHide={() => {}} size="md">
                <Modal.Body
                    style={{
                        backgroundColor: dmode ? '#2f353e' : '',
                    }}
                    className="modal-body-confirm-modal"
                    dir={dir}
                >
                    <Row className="align-items-center justify-content-between">
                        <Col xs="auto">
                            <span
                                className={`head-line-confirm ${
                                    dmode && 'head-dark'
                                }`}
                            >
                                {t(
                                    diffrentDimentionChangeObject?.differenceType
                                )}
                            </span>
                        </Col>
                        <Col xs="auto">
                            <button
                                className="head-close-button"
                                onClick={() => toggleFunc()}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="1.3"
                                    stroke="#4F4F4F"
                                    class="size-4"
                                    width="25"
                                    height="25"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M6 18 18 6M6 6l12 12"
                                    />
                                </svg>
                            </button>
                        </Col>
                    </Row>
                    <div className="mt-3">
                        <span
                            style={{
                                fontSize: 16,
                                fontWeight: 600,
                                color: dmode ? '#fff' : '#000',
                            }}
                        >
                            {t(msgType)}
                        </span>
                        <div
                            style={{
                                fontSize: 13,
                                fontWeight: 400,
                                marginTop: 5,
                                fontStyle: 'italic',
                                letterSpacing: 0.5,
                                color: dmode ? '#fff' : '#000',
                            }}
                        >
                            {
                                diffrentDimentionChangeObject?.differences
                                    ?.message
                            }
                        </div>
                    </div>

                    <Row className="align-items-center justify-content-center mt-3">
                        <Col xs="auto">
                            <Button
                                style={{ textTransform: 'uppercase' }}
                                dir={dir}
                                variant="outline-secondary"
                                className="btn-custom-apply-simulation"
                                onClick={() => toggleFunc()}
                            >
                                <span className="btn-name">
                                    {t('btnnames.close')}
                                </span>
                            </Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CopyArrangementValidationModal
